/* eslint-disable no-restricted-imports */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Button} from '../../../../common/Button/Button'
import styles from './ActionButtons.module.scss'
import {useUIGameEndContext} from '../../../../contexts/UIGameEndContext'
import {T} from '../../../../common/T'
import {LobbyImage, ModeSettingEnum} from '@colonist/types'
import {UIEndGameTitleImage} from '../../../../../../../code/client/shared/scripts/ui_share_image/UIEndGameTitleImage'
import {UIEndGameShareImage} from '../../../../../../../code/client/shared/scripts/ui_share_image/UIEndGameShareImage'
import {ViewPopupShareImage} from '../../../../../../../code/client/shared/scripts/ui_popup/ViewPopupShareImage'
import {CA} from '../../../../../../../code/client/shared/scripts/analytics/Analytics'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../../../code/shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../../../../code/shared/AjaxDataTypes'
import {getLobbyImagePath} from '../../../../../../../code/client/shared/scripts/ui_utils/Utils'
import {useUIGameManagerContext} from '../../../../contexts/UIGameManagerContext'
import {UIUtilsEjsVariables} from '../../../../../../../code/client/shared/scripts/UIUtilsEjsVariables'
import {SDKRequest} from '../../../../../../../code/shared/DiscordActivityTypes'

export function ShareButton() {
    const gameManager = useUIGameManagerContext()
    const {gameEndData, currentPlayerEndgameState} = useUIGameEndContext()
    const [isLoadingShare, setIsLoadingShare] = useState(false)

    // TODO: @Dang Refactor this when popup is refactored with React
    const shareImageRef = useRef<UIEndGameShareImage | null>(null)
    const titleImageRef = useRef<UIEndGameTitleImage | null>(null)
    useEffect(() => {
        const existedShareContainer = document.getElementsByClassName('share-image-container')
        if(existedShareContainer.length > 0) {
            existedShareContainer[0].remove()
        }
        const shareImage = new UIEndGameShareImage(gameManager, gameEndData.endGameState, (isLoading) => setIsLoadingShare(isLoading))
        shareImageRef.current = shareImage
        if((currentPlayerEndgameState?.title) != null) {
            const titleImage = new UIEndGameTitleImage(gameManager, currentPlayerEndgameState.title, gameEndData.endGameState)
            titleImageRef.current = titleImage
        }
    }, [])

    const onShareClick = () => {
        if(!shareImageRef.current) return

        let shareImagePopup: ViewPopupShareImage | null = null
        if((titleImageRef?.current) != null) {
            shareImagePopup = new ViewPopupShareImage(titleImageRef?.current, shareImageRef.current, true)
        } else {
            shareImagePopup = new ViewPopupShareImage(shareImageRef.current)
        }

        if(UIUtilsEjsVariables.isUserOnDiscord) {
            const shareAction = async(image: UIEndGameShareImage) => {
                const imageFile = await image.getImageFile()
                if(imageFile == undefined) return

                const {DiscordInstance} = await import('../../../../../../../code/client/web/scripts/discord/DiscordInstance.ts')
                void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareMoment, imageFile)

                sendDiscordShareAnalytic()
            }

            shareImagePopup.setShareAction(shareAction)
        }

        sendShareButtonClickAnalytic()
    }

    const sendShareButtonClickAnalytic = () => {
        const endGameShareEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareButton,
        }
        void CA.sendAnalyticEventOnce(endGameShareEvent)
    }

    const sendDiscordShareAnalytic = () => {
        const discordShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareDiscordButton,
        }
        void CA.sendAnalyticEventOnce(discordShareClickEvent)
    }

    const isSharingEnabled = useMemo(() => {
        const isMobile = UIUtilsEjsVariables.isUserOnMobile
        const isBeginnerMode = gameManager.gameState.gameModeData.modeSetting == ModeSettingEnum.BeginnerModeClassic4P
        return !isBeginnerMode && !isMobile
    }, [gameManager])

    return (
        <>
            {(isSharingEnabled) && <Button
                className={styles.button}
                isLoading={isLoadingShare}
                onClick={onShareClick}
            >
                <T id={{key: 'strings:game.endGame.cornerButton.share'}}/>
                {UIUtilsEjsVariables.isUserOnDiscord ?
                    <img className={styles.icon} src={getLobbyImagePath(LobbyImage.DiscordIcon)}/> :
                    <img className={styles.icon} src={getLobbyImagePath(LobbyImage.Share)}/>
                }
            </Button>}
        </>
    )
}
